import React, { Fragment, useState, useEffect } from "react";
import UploadButtonInput from "ReusableComponents/UploadButtonInput";
import cloneDeep from "lodash.clonedeep";
import { Input, Row, Col, Typography, Button } from 'antd';
import Checkbox from "antd/es/checkbox/index";
import Title from 'antd/es/typography/Title';
import Text from 'antd/es/typography/Text';
import TranslatedText from "translations/TranslatedText";
import Icon from "antd/es/icon/index";

export default function OneForAll(props) {
  const {
    language,
    options: defaultOptions,
    onChange,
  } = props;
  const [options, setOptions] = useState(defaultOptions[language])

  const saveTitle = (value: string, index: number) => {
    const optionsClone = cloneDeep(options);
    optionsClone[index].value = value;
    setOptions(optionsClone);
  }

  const setAnswerProp = (index: number) => {
    const optionsClone = cloneDeep(options);
    optionsClone[index].is_answer = !optionsClone[index].is_answer;
    setOptions(optionsClone);
  }

  const addOption = () => {
    const optionsClone = cloneDeep(options);
    optionsClone.push({
      value: "",
      is_answer: false,
      select: 1,
    })
    setOptions(optionsClone)
  }

  const removeOption = (index) => {
    const optionsClone = cloneDeep(options);
    optionsClone.splice(index, 1);
    setOptions(optionsClone)
  }

  useEffect(() => {
    const defaultOptionsClone = cloneDeep(defaultOptions);
    defaultOptionsClone[language] = options;
    onChange(defaultOptionsClone);
  }, [options]);

  return (
    <Fragment>
      <Row type="flex" justify="space-between" align="middle">
        <Col xs={{ span: 8 }} sm={{ span: 8 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }}>
          <Typography style={{ textAlign: 'center' }}>
            <TranslatedText id="settings.form.multichoice.responses.text" />
          </Typography>
        </Col>
        <Col xs={{ span: 8 }} sm={{ span: 8 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }}>
          <Typography style={{ textAlign: 'center' }}>
            <TranslatedText id="settings.form.multichoice.responses.correct" />
          </Typography>
        </Col>
        <Col xs={{ span: 8 }} sm={{ span: 8 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }}></Col>
      </Row>
      {
        options.map((option, index)=>{
          return (
            <Fragment key={index}>
              <Row type="flex" justify="start" align="middle">
                <Col span={6}>
                  <Input
                    onChange={(event)=>saveTitle(event.target.value, index)}
                    style={{ minWidth: '15vw'}}
                    value={option.value}
                  />
                </Col>
                <Col>
                  <Fragment>
                    <Button onClick={()=>addOption()}>
                      <Icon type="plus-circle" />
                    </Button>
                    {options.length > 1 && (
                      <Button onClick={()=>removeOption(index)}>
                        <Icon type="minus-circle" />
                      </Button>
                    )}
                  </Fragment>
                </Col>
                <Col push={1}>
                  <Checkbox
                    onChange={event=>setAnswerProp(index)}
                    checked={option.is_answer}
                  >
                    {option.is_answer ? "correct" : "incorrect"}
                  </Checkbox>
                </Col>
              </Row>
            </Fragment>
          )
        })
      }
    </Fragment>
  );
};